import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Container, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const BussinessProperty = () => {
  return (
    <div>
      <Row>
        <CardNav Header="Bussiness Property" />

        <Col lg="12">
          <Card className="shadow-main">
            <BoxData
              Title="Single Item"
              Butonn="Create Shop"
              imgg={images.SellProperties}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BussinessProperty;
